export default __webpack_public_path__ + "img/a0af669ee9b5d5cff44d521ab9b9310d.svg";